// Screen 9 — Meal preferences (wizard step 8 of 9). "No preference" mutex.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardScreen } from '../../components/planner/WizardScreen';
import { CheckboxList } from '../../components/planner/CheckboxList';
import { FieldError } from '../../components/planner/FieldError';
import { useDraft, STEP_ROUTES } from '../../lib/plannerDraft';

const PREFERENCES = [
  { id: 'no_preference', label: 'No preference' },
  { id: 'chicken', label: 'Chicken' },
  { id: 'steak', label: 'Steak' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'breakfast_meals', label: 'Breakfast meals' },
  { id: 'no_salads', label: 'No salads', description: 'Exclude salads from my meal plans' },
];

export default function Step9Preferences() {
  const nav = useNavigate();
  const { draft, patch, bump } = useDraft();
  const [showErr, setShowErr] = useState(false);

  const valid = Array.isArray(draft.preferences) && draft.preferences.length > 0;

  const onContinue = () => {
    if (!valid) { setShowErr(true); return; }
    bump(9);
    nav(STEP_ROUTES[9]);
  };

  return (
    <WizardScreen
      step={8}
      eyebrow="Preferences"
      title="Your preferences"
      canContinue={valid}
      onContinue={onContinue}
      submitLabel="Build my plans"
    >
      <p className="text-sm mb-5" style={{ color: 'var(--text-dim)' }}>
        We&apos;ll prioritize these when we choose your meals — they never
        exclude anything from your plan.
      </p>

      <CheckboxList
        options={PREFERENCES}
        value={draft.preferences}
        mutexId="no_preference"
        onChange={(v) => patch({ preferences: v }, { invalidateGeneration: true })}
        ariaLabel="Preferences"
        testIdPrefix="preference"
      />

      <FieldError id="preferences-error">
        {showErr && !valid ? 'Please choose at least one option.' : null}
      </FieldError>
    </WizardScreen>
  );
}
